import React, { Component } from 'react';
import Helmet from 'react-helmet';
import withAuth from './WithAuth';
import constants from '../config';

function StrikeMeter(props) {
  var count = props.count;
  var label = 'Good Standing';
  var labelColor = '#22c55e';
  if (count >= 3) { label = 'Suspended'; labelColor = '#ef4444'; }
  else if (count === 2) { label = 'Final Warning'; labelColor = '#f59e0b'; }
  else if (count === 1) { label = 'Warning'; labelColor = '#f59e0b'; }

  var circles = [];
  for (var i = 0; i < 3; i++) {
    var filled = i < count;
    circles.push(
      <React.Fragment key={i}>
        {i > 0 && (
          <div
            className="tw-flex-1 tw-h-[3px]"
            style={{ backgroundColor: i < count ? '#ef4444' : '#e5e7eb' }}
          />
        )}
        <div
          className="tw-w-9 tw-h-9 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-bold tw-flex-shrink-0"
          style={{
            backgroundColor: filled ? '#ef4444' : 'transparent',
            border: filled ? '3px solid #ef4444' : '3px solid #d1d5db',
            color: filled ? '#fff' : '#9ca3af',
          }}
        >
          {filled ? <i className="fa fa-times" /> : i + 1}
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6 tw-mb-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
      <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-5">Strike Meter</h2>
      <div className="tw-flex tw-items-center tw-gap-0 tw-mb-4 tw-px-4">
        {circles}
      </div>
      <div className="tw-text-center tw-text-sm tw-font-semibold" style={{ color: labelColor }}>
        {count}/3 Strikes — {label}
      </div>
    </div>
  );
}

function AppealStatusBadge(props) {
  var status = props.status;
  if (status === 'pending') {
    return (
      <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-semibold tw-px-2.5 tw-py-1 tw-rounded-full" style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}>
        <i className="fa fa-clock-o" /> Appeal Pending
      </span>
    );
  }
  if (status === 'approved') {
    return (
      <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-semibold tw-px-2.5 tw-py-1 tw-rounded-full" style={{ backgroundColor: '#ECFDF5', color: '#065F46' }}>
        <i className="fa fa-check" /> Appeal Approved
      </span>
    );
  }
  if (status === 'denied') {
    return (
      <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-semibold tw-px-2.5 tw-py-1 tw-rounded-full" style={{ backgroundColor: '#FEE2E2', color: '#991B1B' }}>
        <i className="fa fa-times" /> Appeal Denied
      </span>
    );
  }
  return null;
}

function StrikeCard(props) {
  var s = props.strike;
  var date = new Date(s.createdAt);
  var dateStr = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  var appealStatus = s.appealStatus || 'none';

  return (
    <div className="tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-overflow-hidden tw-mb-3" style={{ borderLeft: '4px solid #ef4444' }}>
      <div className="tw-p-4">
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center tw-gap-2.5">
            <i className="fa fa-exclamation-triangle" style={{ color: '#ef4444' }} />
            <span className="tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-text-sm">{s.reason}</span>
          </div>
          <span className="tw-text-xs tw-text-[#999] tw-flex-shrink-0 tw-ml-4">{dateStr}</span>
        </div>
        {s.details && (
          <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0 tw-mt-2 tw-ml-7">{s.details}</p>
        )}
      </div>

      {/* Appeal status badge */}
      {appealStatus !== 'none' && (
        <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-px-4 tw-py-3" style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
          <AppealStatusBadge status={appealStatus} />
          {appealStatus === 'pending' && s.appealedAt && (
            <p className="tw-text-xs tw-text-[#999] tw-mt-1.5 tw-mb-0">
              Submitted {new Date(s.appealedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          )}
          {appealStatus === 'denied' && s.appealResponse && (
            <div className="tw-mt-2.5 tw-rounded-lg tw-p-3" style={{ backgroundColor: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.15)' }}>
              <p className="tw-text-xs tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">Admin Response:</p>
              <p className="tw-text-xs tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">{s.appealResponse}</p>
            </div>
          )}
        </div>
      )}

      {/* Appeal button */}
      {appealStatus === 'none' && (
        <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-px-4 tw-py-3" style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
          <button
            className="tw-text-xs tw-font-semibold tw-px-3.5 tw-py-2 tw-rounded-lg tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
            style={{ backgroundColor: 'rgba(99,102,241,0.1)', color: '#6366f1' }}
            onClick={function() { props.onAppealClick(s._id); }}
          >
            <i className="fa fa-gavel tw-mr-1.5" />Appeal This Strike
          </button>
        </div>
      )}
    </div>
  );
}

class AccountStanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      data: null,
      appealingStrikeId: null,
      appealText: '',
      appealSubmitting: false,
      appealError: null,
      appealSuccess: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchStanding();
    this.dismissStrikeNotifications();
  }

  dismissStrikeNotifications() {
    var authHeader = require('../utils/authHeader').getAuthHeader();
    var userId = this.props.user ? this.props.user._id : null;
    if (!userId || !authHeader) return;
    fetch(constants.DOMAIN + '/api/v1/users/' + userId, {
      headers: { Authorization: authHeader },
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var strikeNotifs = (data.systemNotifications || []).filter(function(n) { return n.type === 'strike' || n.type === 'strike_appeal'; });
        strikeNotifs.forEach(function(n) {
          fetch(constants.DOMAIN + '/api/v1/users/notifications/' + n._id + '/dismiss', {
            method: 'POST',
            headers: { Authorization: authHeader },
          });
        });
      })
      .catch(function() {});
  }

  fetchStanding() {
    var authHeader = require('../utils/authHeader').getAuthHeader();
    fetch(constants.DOMAIN + '/api/v1/users/account-standing', {
      headers: { Authorization: authHeader },
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Failed to load');
        return res.json();
      })
      .then(function(data) {
        this.setState({ data: data, loading: false });
      }.bind(this))
      .catch(function(err) {
        this.setState({ error: err.message, loading: false });
      }.bind(this));
  }

  submitAppeal() {
    var self = this;
    var strikeId = this.state.appealingStrikeId;
    var reason = this.state.appealText.trim();

    if (reason.length < 20) {
      this.setState({ appealError: 'Please provide a reason of at least 20 characters.' });
      return;
    }

    this.setState({ appealSubmitting: true, appealError: null });
    var authHeader = require('../utils/authHeader').getAuthHeader();

    fetch(constants.DOMAIN + '/api/v1/users/account-standing/appeal', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader,
      },
      body: JSON.stringify({ strikeId: strikeId, reason: reason }),
    })
      .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
      .then(function(result) {
        if (!result.ok) {
          self.setState({ appealError: result.data.error || 'Failed to submit appeal', appealSubmitting: false });
          return;
        }
        // Update the strike in local state
        var data = self.state.data;
        var updatedStrikes = data.strikes.map(function(s) {
          if (s._id === strikeId) {
            return result.data.strike;
          }
          return s;
        });
        self.setState({
          data: Object.assign({}, data, { strikes: updatedStrikes }),
          appealingStrikeId: null,
          appealText: '',
          appealSubmitting: false,
          appealSuccess: 'Your appeal has been submitted. We will review it within 3-5 business days.',
        });
        // Clear success message after 5 seconds
        setTimeout(function() { self.setState({ appealSuccess: null }); }, 5000);
      })
      .catch(function() {
        self.setState({ appealError: 'Network error. Please try again.', appealSubmitting: false });
      });
  }

  renderStatusBanner() {
    var d = this.state.data;
    if (d.status === 'banned') {
      return (
        <div className="tw-rounded-2xl tw-p-5 tw-mb-6 tw-flex tw-items-center tw-gap-4" style={{ backgroundColor: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)' }}>
          <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: 'rgba(239,68,68,0.15)' }}>
            <i className="fa fa-ban tw-text-xl" style={{ color: '#ef4444' }} />
          </div>
          <div>
            <h2 className="tw-text-lg tw-font-bold tw-mb-1" style={{ color: '#ef4444' }}>Account Banned</h2>
            {d.bannedReason && <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">Reason: {d.bannedReason}</p>}
          </div>
        </div>
      );
    }
    if (d.status === 'suspended') {
      var until = d.suspendedUntil ? new Date(d.suspendedUntil).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : null;
      return (
        <div className="tw-rounded-2xl tw-p-5 tw-mb-6 tw-flex tw-items-center tw-gap-4" style={{ backgroundColor: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)' }}>
          <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: 'rgba(245,158,11,0.15)' }}>
            <i className="fa fa-pause-circle tw-text-xl" style={{ color: '#f59e0b' }} />
          </div>
          <div>
            <h2 className="tw-text-lg tw-font-bold tw-mb-1" style={{ color: '#f59e0b' }}>Account Suspended</h2>
            {d.suspendedReason && <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">Reason: {d.suspendedReason}</p>}
            {until && <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">Suspended until: {until}</p>}
          </div>
        </div>
      );
    }
    // active / good standing
    if (d.strikeCount === 0) {
      return (
        <div className="tw-rounded-2xl tw-p-5 tw-mb-6 tw-flex tw-items-center tw-gap-4" style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.2)' }}>
          <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: 'rgba(34,197,94,0.15)' }}>
            <i className="fa fa-check-circle tw-text-xl" style={{ color: '#22c55e' }} />
          </div>
          <div>
            <h2 className="tw-text-lg tw-font-bold tw-mb-1" style={{ color: '#22c55e' }}>Your account is in good standing</h2>
            <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">No strikes or violations on your account.</p>
          </div>
        </div>
      );
    }
    // active but has strikes
    return (
      <div className="tw-rounded-2xl tw-p-5 tw-mb-6 tw-flex tw-items-center tw-gap-4" style={{ backgroundColor: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)' }}>
        <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: 'rgba(245,158,11,0.15)' }}>
          <i className="fa fa-exclamation-triangle tw-text-xl" style={{ color: '#f59e0b' }} />
        </div>
        <div>
          <h2 className="tw-text-lg tw-font-bold tw-mb-1" style={{ color: '#f59e0b' }}>
            {d.strikeCount === 1 ? 'Warning — 1 Strike' : 'Final Warning — ' + d.strikeCount + ' Strikes'}
          </h2>
          <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">Please review the details below to avoid further action.</p>
        </div>
      </div>
    );
  }

  render() {
    var self = this;
    var s = this.state;
    var isDark = document.documentElement.classList.contains('tw-dark');

    if (s.loading) {
      return (
        <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#0a0a0a' : '#f5f5f5' }}>
          <i className="fa fa-spinner fa-spin tw-text-2xl" style={{ color: '#c9a84c' }} />
        </div>
      );
    }

    if (s.error) {
      return (
        <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#0a0a0a' : '#f5f5f5' }}>
          <p className="tw-text-[#999]">Failed to load account standing.</p>
        </div>
      );
    }

    var d = s.data;

    return (
      <div style={{ backgroundColor: isDark ? '#0a0a0a' : '#f5f5f5', minHeight: '100vh' }}>
        <Helmet><title>Account Standing | Primal TCG</title></Helmet>
        <div className="tw-max-w-2xl tw-mx-auto tw-px-4 tw-py-10">

          {/* Header */}
          <div className="tw-mb-8">
            <h1 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">Account Standing</h1>
            <p className="tw-text-sm tw-text-[#999]">View your account status, strike history, and community guidelines.</p>
          </div>

          {/* Appeal success message */}
          {s.appealSuccess && (
            <div className="tw-rounded-2xl tw-p-4 tw-mb-6 tw-flex tw-items-center tw-gap-3" style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.2)' }}>
              <i className="fa fa-check-circle" style={{ color: '#22c55e' }} />
              <span className="tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white">{s.appealSuccess}</span>
            </div>
          )}

          {/* Status Banner */}
          {this.renderStatusBanner()}

          {/* Strike Meter */}
          <StrikeMeter count={d.strikeCount} />

          {/* How Strikes Work */}
          <div className="tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6 tw-mb-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
            <div className="tw-flex tw-items-center tw-gap-2.5 tw-mb-4">
              <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-flex-shrink-0" style={{ backgroundColor: 'rgba(201,168,76,0.1)', color: '#c9a84c' }}>
                <i className="fa fa-info-circle" />
              </div>
              <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">How Strikes Work</h2>
            </div>
            <div className="tw-space-y-4 tw-text-sm tw-text-[#666] dark:tw-text-gray-400">
              <div className="tw-flex tw-items-center tw-gap-3">
                <span className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-flex-shrink-0" style={{ backgroundColor: 'rgba(245,158,11,0.15)', color: '#f59e0b' }}>1</span>
                <span><strong className="tw-text-[#1a1a1a] dark:tw-text-white">1 strike</strong> — Warning issued. Review your listing practices.</span>
              </div>
              <div className="tw-flex tw-items-center tw-gap-3">
                <span className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-flex-shrink-0" style={{ backgroundColor: 'rgba(245,158,11,0.15)', color: '#f59e0b' }}>2</span>
                <span><strong className="tw-text-[#1a1a1a] dark:tw-text-white">2 strikes</strong> — Final warning. One more will result in suspension.</span>
              </div>
              <div className="tw-flex tw-items-center tw-gap-3">
                <span className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-flex-shrink-0" style={{ backgroundColor: 'rgba(239,68,68,0.15)', color: '#ef4444' }}>3</span>
                <span><strong className="tw-text-[#1a1a1a] dark:tw-text-white">3 strikes</strong> — Automatic 7-day suspension.</span>
              </div>
              <div className="tw-flex tw-items-center tw-gap-3">
                <span className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-flex-shrink-0" style={{ backgroundColor: 'rgba(239,68,68,0.15)', color: '#ef4444' }}>
                  <i className="fa fa-ban tw-text-[10px]" />
                </span>
                <span><strong className="tw-text-[#1a1a1a] dark:tw-text-white">Continued violations</strong> — May result in a permanent ban.</span>
              </div>
            </div>
          </div>

          {/* Strike History */}
          <div className="tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6 tw-mb-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
            <div className="tw-flex tw-items-center tw-gap-2.5 tw-mb-4">
              <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-flex-shrink-0" style={{ backgroundColor: 'rgba(239,68,68,0.1)', color: '#ef4444' }}>
                <i className="fa fa-history" />
              </div>
              <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Strike History</h2>
            </div>
            {d.strikes.length === 0 ? (
              <p className="tw-text-sm tw-text-[#999] tw-text-center tw-py-4 tw-mb-0">No strikes on your account.</p>
            ) : (
              d.strikes.map(function(strike) {
                return <StrikeCard key={strike._id} strike={strike} onAppealClick={function(strikeId) { self.setState({ appealingStrikeId: strikeId, appealText: '', appealError: null }); }} />;
              })
            )}
          </div>

          {/* Appeal Form (shown when user clicks Appeal on a strike) */}
          {s.appealingStrikeId && (
            <div className="tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6 tw-mb-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)', borderLeft: '4px solid #6366f1' }}>
              <div className="tw-flex tw-items-center tw-gap-2.5 tw-mb-4">
                <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-flex-shrink-0" style={{ backgroundColor: 'rgba(99,102,241,0.1)', color: '#6366f1' }}>
                  <i className="fa fa-gavel" />
                </div>
                <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Submit Appeal</h2>
              </div>
              <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-3">
                Explain why you believe this strike was issued in error. Our team will review your appeal within 3-5 business days.
              </p>
              <textarea
                className="tw-w-full tw-rounded-lg tw-border tw-border-[#ddd] dark:tw-border-[#333] tw-bg-white dark:tw-bg-[#1a1a1a] tw-text-[#1a1a1a] dark:tw-text-white tw-text-sm tw-p-3 tw-resize-none"
                rows="4"
                placeholder="Describe the situation in detail (minimum 20 characters)..."
                value={s.appealText}
                onChange={function(e) { self.setState({ appealText: e.target.value, appealError: null }); }}
                disabled={s.appealSubmitting}
                style={{ outline: 'none' }}
              />
              <div className="tw-text-xs tw-text-[#999] tw-mt-1 tw-mb-3">
                {s.appealText.length}/20 minimum characters
              </div>
              {s.appealError && (
                <div className="tw-text-xs tw-mb-3" style={{ color: '#ef4444' }}>
                  <i className="fa fa-exclamation-circle tw-mr-1" />{s.appealError}
                </div>
              )}
              <div className="tw-flex tw-gap-2">
                <button
                  className="tw-text-sm tw-font-semibold tw-px-4 tw-py-2 tw-rounded-lg tw-border-0 tw-cursor-pointer tw-text-white hover:tw-opacity-90"
                  style={{ backgroundColor: '#6366f1', opacity: s.appealSubmitting || s.appealText.trim().length < 20 ? 0.5 : 1 }}
                  disabled={s.appealSubmitting || s.appealText.trim().length < 20}
                  onClick={function() { self.submitAppeal(); }}
                >
                  {s.appealSubmitting ? (
                    <span><i className="fa fa-spinner fa-spin tw-mr-1" />Submitting...</span>
                  ) : (
                    <span><i className="fa fa-paper-plane tw-mr-1" />Submit Appeal</span>
                  )}
                </button>
                <button
                  className="tw-text-sm tw-font-medium tw-px-4 tw-py-2 tw-rounded-lg tw-border tw-border-[#ddd] dark:tw-border-[#333] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222]"
                  onClick={function() { self.setState({ appealingStrikeId: null, appealText: '', appealError: null }); }}
                  disabled={s.appealSubmitting}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          {/* Support fallback */}
          <div className="tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
            <div className="tw-flex tw-items-center tw-gap-2.5 tw-mb-4">
              <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-flex-shrink-0" style={{ backgroundColor: 'rgba(99,102,241,0.1)', color: '#6366f1' }}>
                <i className="fa fa-envelope" />
              </div>
              <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Need Help?</h2>
            </div>
            <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">
              You can also reach us at{' '}
              <a href="mailto:dattebayolabs@gmail.com" className="tw-font-semibold" style={{ color: '#c9a84c' }}>
                dattebayolabs@gmail.com
              </a>{' '}
              for any questions about your account standing or the appeal process.
            </p>
          </div>

        </div>
      </div>
    );
  }
}

export default withAuth(AccountStanding);
